import styled from "styled-components";

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100vh - 280px);
    overflow-y: auto;
`
export const ConfigPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    padding-right: 8px;
`
export const TopWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 28px;
    width: 100%;
    padding: 24px 0px;
`
export const TopBottomWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
`
export const TopActionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 100%;
`
export const ChatStartersSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    & > * {
        width: 100%;
    }
`
export const ChatStartersContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    & > * {
        width: 100%;
    }
`

export const ChatStarterInputWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px 16px;
    gap: 4px;
    width: 100%;
    border: 1px solid #5C5C5C;
    border-radius: 8px;
`
export const ChatStarterInput = styled.input`
    display: flex;
    flex-direction: row;
    flex: 1;
    border: none;
    outline: none;
`
export const TagsSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;

`
export const AddTagsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    width: 100%;
`

export const TagsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    width: 100%;
`

export const CircularProgressContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`